import { Modal } from 'antd';
import styled, { css } from 'styled-components';
import { buttonSizeStyles } from '@rockalingua/ui';

import Colors from '@/v2/constants/Colors';
import MediaQueryBreakpoints from '@/v2/constants/MediaQueryBreakpoints';

export const Container = styled(Modal)`
  top: 80px;
  height: calc(100vh - 160px);
  padding-bottom: 0px;

  .ant-modal-content {
    padding-top: 24px;
    max-height: 100%;

    display: flex;
    flex-direction: column;

    .ant-modal-close {
      top: 11px;
      color: ${Colors.MAIN_VARIANTS[60]};
    }

    .ant-modal-header {
      padding-top: 0;
      border-bottom: none;
    }

    .ant-modal-body {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      padding-bottom: 0;

      ${({ $scrollable }) =>
        $scrollable &&
        css`
          padding: 0;
          overflow-y: hidden;
        `}

      ${({ $scrollable }) =>
        !$scrollable &&
        css`
          overflow-y: auto;
        `}
    }

    .ant-modal-footer {
      flex-shrink: 0;
      display: flex;
      padding: 24px 24px 24px;

      border-top: none;
      justify-content: flex-end;
      gap: 24px;

      .ant-btn {
        ${buttonSizeStyles.large}
        padding-left: 80px;
        padding-right: 80px;
      }
    }
  }

  @media (${MediaQueryBreakpoints.isUltraWide}) {
    top: 20px;
    height: calc(100vh - 40px);

    .ant-modal-header {
      padding-bottom: 0;
    }
  }
`;

export const ScrollableContainer = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  padding: 24px;
`;

export const FooterContainer = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 16px;
`;

export const ErrorContainer = styled.div`
  flex-grow: 1;

  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 24px;
`;
